import { FormEvent, useState } from 'react';
import { LockKeyhole } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';

export default function UnlockVaultDialog() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLocked = useAuthStore((state) => state.isLocked);
  const unlock = useAuthStore((state) => state.unlock);
  const logout = useAuthStore((state) => state.logout);
  const [password, setPassword] = useState('');
  const [isUnlocking, setIsUnlocking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isAuthenticated || !isLocked) return null;

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setIsUnlocking(true);
    setError(null);
    try {
      await unlock(password);
      setPassword('');
    } catch {
      setError('No se pudo desbloquear el proyecto. Comprueba tu contraseña maestra.');
    } finally {
      setIsUnlocking(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <form onSubmit={handleSubmit} className="w-full max-w-md rounded-xl border border-outline-variant bg-surface-container p-6 shadow-2xl">
        <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-primary-container/20 text-primary">
          <LockKeyhole className="h-5 w-5" />
        </div>
        <h2 className="text-xl font-bold text-on-surface">Desbloquea tu proyecto</h2>
        <p className="mt-2 text-sm text-on-surface-variant">
          Por seguridad, la clave maestra se elimina al recargar. Tu contraseña se usa solo en este navegador para recuperarla.
        </p>
        <label htmlFor="unlock-master-password" className="mt-5 block text-sm font-medium text-on-surface">
          Contraseña maestra
        </label>
        <input
          id="unlock-master-password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          className="mt-2 w-full rounded-lg border border-outline-variant bg-surface-container-lowest px-3 py-2.5 text-on-surface outline-none focus:border-primary"
          required
          autoFocus
        />
        {error && <p className="mt-3 text-sm text-error">{error}</p>}
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" onClick={logout} className="btn-secondary">Cerrar sesión</button>
          <button type="submit" disabled={isUnlocking} className="btn-primary disabled:opacity-50">
            {isUnlocking ? 'Desbloqueando…' : 'Desbloquear'}
          </button>
        </div>
      </form>
    </div>
  );
}
